import { SlotObserver } from './slot-observer';
import { assertTargetGetElem } from './util';
import {logError} from './log';
import { CampaignRenderer } from './campaign-renderer';
import { getMetadata } from './analytics';
import { checkCampaign, ackCampaign } from './api-client';

export class MarketingLoaderEngine {
  constructor ({
    doNotTrack = false,
    slotObserver,
    campaignRenderer
  }) {
    this.doNotTrack = doNotTrack;
    this.slotObserver = slotObserver || new SlotObserver({ onSlotMount: this.mountSlot });
    this.campaignRenderer = campaignRenderer || new CampaignRenderer();
  }

  start = () => {
    this.slotObserver.startObserving();
  };

  stop = () => {
    this.slotObserver.stopObserving();
  };

  mountSlot = async (targetIdOrElem, slotProps) => {
    try {
      const slotElement = assertTargetGetElem(targetIdOrElem);
      const { reactComponentName, renderProps, campaignName, id: campaignId } = await checkCampaign({
        ...getMetadata(),
        ...slotProps
      });
      if (!campaignName) {
        // no relevant campaign
        return;
      }
      this.campaignRenderer.renderCampaign({
        slotElement,
        slotProps,
        reactComponentName,
        renderProps,
        campaignName,
        campaignId
      });
    } catch (error) {
      logError(error);
    }
  };

  ackSlot = async (campaignId) => {
    try {
      await ackCampaign(campaignId);
    } catch (error) {
      logError(error);
    }
  };

  // used for debugging
  renderCampaign = (targetIdOrElem, reactComponentName, renderProps) => {
    const slotElement = assertTargetGetElem(targetIdOrElem);
    this.campaignRenderer.renderCampaign({
      slotElement,
      reactComponentName,
      renderProps
    });
  };
}

let engineInstance;

const init = (debug) => {
  engineInstance = new MarketingLoaderEngine({ doNotTrack: debug });
  return engineInstance;
};

export default init;
